import React from 'react';
import PropTypes from 'prop-types';
import SimpleChartJSBarChart from '@components/Charts/SimpleChartJSBarChart/SimpleChartJSBarChart';
import { useDisplayUnit, useTheme } from '@hooks';
import { NoDataAvailable } from '@components/Display';

function TotalPerDrillingActivityChart({ unit, totalSeries, totalCategories, loading }) {
  const { displayUnit } = useDisplayUnit();  
  const { theme } = useTheme();
    const {
      palette: {
        charts: { twoColorsSameType }
      }
    } = theme;

    const chartSeries = (totalCategories || []).map((cat, idx) => ({
      label: cat,
      data: [{ x: cat, y: totalSeries?.[0]?.data?.[idx] ?? totalSeries?.[0]?.[idx] ?? 0 }],
      borderColor: twoColorsSameType[0],
      backgroundColor: twoColorsSameType[0],
      borderSkipped: true,
      barPercentage: 0.6,
      unit: unit
    }));

  if (!loading && (!totalSeries?.length || !totalCategories?.length || NoDataAvailable.hasNoData(chartSeries))) {
    return <NoDataAvailable height="450px" />;
  }

  return (
    <SimpleChartJSBarChart
      id="drilling-activity-summary-chart"
      loading={loading}
      height='450px'
      series={chartSeries}
      unit={unit}
      tooltipTitle={displayUnit}
      // horizontal bars (categories on Y axis)
      isHorizontal
    />
  );
}

TotalPerDrillingActivityChart.propTypes = {
  unit: PropTypes.string,
  totalSeries: PropTypes.arrayOf(PropTypes.object),
  totalCategories: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool
};

TotalPerDrillingActivityChart.defaultProps = {
  unit: '',
  totalSeries: [],
  totalCategories: [],
  loading: false
};

export default TotalPerDrillingActivityChart;
